import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  ButtonGroup,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import TableSkeleton from "../../../StyledComponents/TableSkeleton";
import ReturnBatch from "../Treasury/ReturnBatch";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function TreasureTable(treasurList, loading) {
  const classes = useStyles();
  const [openReturnBatch, setopenReturnBatch] = useState(false);

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} mt={3}>
          <TableContainer className="scrollable">
            <Table
             className={classes.table}
             aria-label="a dense table"
             // padding="normal"
             size="small"
             sx={{
               height: 40,
             }}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    Batch No
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    Batch Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    Vendor Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    No.of Invoices
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    Batch Amount
                  </TableCell>

                  <TableCell
                    sx={{
                      // textAlign: "center",
                      fontWeight: "bold",
                      color: "#fff",
                    }}
                  >
                    Action Performed
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                  Batch No
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                  Batch Date
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                  Vendor Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                  No.of Invoices
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                  Batch Amount
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#fff" }}
                  style={{ width: "20%" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      // alignItems: 'center',
                      "& > *": {
                        m: 1,
                      },
                      fontWeight: "bold",
                      color: "#fff",
                    }}
                  >
                    <ButtonGroup
                      variant="outlined"
                      aria-label="outlined primary button group"
                      color="secondary"
                    >
                      <Button>Download</Button>
                      <Button onClick={setopenReturnBatch}>Return</Button>
                      <Button>Comments</Button>
                    </ButtonGroup>
                  </Box>
                </TableCell>
              </TableBody>
              {/*  {loading && <TableSkeleton noOfColumns={6} noOfLines={3} />} */}
            </Table>
            {/*{treasurList?.length === 0 && !loading ? <EmptyData /> : ""} */}
          </TableContainer>
          {openReturnBatch && (
            <ReturnBatch open={openReturnBatch} close={setopenReturnBatch} />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default TreasureTable;
